<template>
    <div><!-- ##&en No content ##&hu Nincs tartalom ## --></div>
</template>

<script>
export default {
    name: "vue-include-no-content",
};
</script>